import { IProductCPSummaryItem } from '@models/reports/current-month-summary';

export const productSummaryChartOptions = {
  // TODO:
  // To make It consistent we need to set the column and row sizes first for the page
  // using CELL_WIDTH and CELL_HEIGHT + using span to merge cells If we want to make them larger
  width: 300,
  height: 700,
  posX: 300,
  posY: 0,
  rowSpaceUsed: 34,
  colSpaceUsed: 7,
  id: 'Product-Summary-Chart'
};

export const productSummaryChartJSON = (productData: any[], totals: IProductCPSummaryItem) => {
  const chart = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie'
    },
    title: {
      text: ''
    },
    tooltip: {
      pointFormat: '<b>{series.name}</b>: {point.percentage:.2f}%'
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.2f} %'
        }
        // ,showInLegend: true
      }
    },
    series: [],
    navigation: {
      buttonOptions: {
        enabled: false
      }
    },
    exporting: {
      sourceWidth: 750,
      sourceHeight: 750
    }
  };

  // Adding data to the pie chart
  const dataPoints = [];
  for (const group of productData) {
    for (const product of group.data) {
      if (typeof product.AvgBalance === 'number' && !isNaN(product.AvgBalance)) {
        const productRelativeWeight: number = totals.AvgBalance !== 0 ? (product.AvgBalance / totals.AvgBalance) * 100 : 0;
        const serieDataPoint = {
          name: product.ProductName,
          y: productRelativeWeight,
          sliced: false,
          selected: false
        };
        dataPoints.push(serieDataPoint);
      }
    }
  }

  chart.series = [
    {
      name: 'Weight of Total',
      // colorByPoint: true,
      data: dataPoints,
      type: 'pie'
    }
  ];

  return chart;
};
